var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 109,
    viewBox: "0 0 63 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6009 107.775C43.4433 107.775 53.8542 106.765 53.8542 105.52C53.8542 104.275 43.4433 103.265 30.6009 103.265C17.7585 103.265 7.34766 104.275 7.34766 105.52C7.34766 106.765 17.7585 107.775 30.6009 107.775Z",
    fill: "#FFC3FE",
    stroke: "#6C7360",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9788 51.6218C7.26107 48.8749 2.31274 31.7043 2.31274 31.7043C2.31274 31.7043 10.4249 35.1729 14.3524 35.8863L25.5972 38.8382L22.9788 51.6136V51.6218Z",
    fill: "#D9F564",
    stroke: "#6C7360",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8233 48.5455L29.847 37.0903C34.7486 31.2438 40.1722 30.6452 42.9854 31.703C46.0947 32.8674 48.5415 36.6229 48.1753 40.8131L61.8748 47.291C62.0852 47.3894 61.9917 47.7256 61.7579 47.6846L45.7128 44.7654C36.2681 50.0215 37.6396 59.2792 31.7406 67.2084C29.1301 70.7098 24.3921 75.0885 22.1245 77.1139C21.6179 77.5649 21.8206 78.434 22.4673 78.5816C30.1821 80.4184 35.8395 84.133 39.9852 87.3637L30.7743 99.6799C22.5764 91.2668 19.0464 78.6964 20.4646 65.1011C21.166 58.4018 22.3505 52.9571 23.8233 48.5455Z",
    fill: "#FAF4DA",
    stroke: "#6C7360",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3646 49.6535C14.1404 46.7917 4.40742 19.5436 21.0837 1.2251L31.7207 44.3154",
    fill: "#FAF4DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3646 49.6535C14.1404 46.7917 4.40742 19.5436 21.0837 1.2251L31.7207 44.3154",
    stroke: "#6C7360",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6819 58.0903C10.6946 57.2048 5.37998 54.3512 1.0083 49.8987",
    stroke: "#6C7360",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7097 44.7663L61.7548 47.6854C61.9808 47.7264 62.0821 47.3903 61.8717 47.2919L48.1722 40.814L45.7097 44.7581V44.7663Z",
    fill: "#9AECBF",
    stroke: "#6C7360",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.1c2f16d83f9e8563dd74e33db16377a5.svg";
export { ForwardRef as ReactComponent };